import { ApiType } from "@gymflow/common";
import { QueryKey } from "@tanstack/react-query";

export const xeroQueryKeys = {
  all: () => ["xero"] as QueryKey,
  getIntegrationStatus: (clubId: number) =>
    [...xeroQueryKeys.all(), clubId, "getIntegrationStatus"] as QueryKey,
  getRedirectUrlToAuthPage: (
    opts: Parameters<ApiType["xeroApi"]["getRedirectUrlToAuthPage"]>[0],
  ) => [...xeroQueryKeys.all(), "getRedirectUrlToAuthPage", opts] as QueryKey,
  getAccountMapping: () =>
    [...xeroQueryKeys.all(), "getAccountMapping"] as QueryKey,
  getAccountMappingOptionList: () =>
    [...xeroQueryKeys.all(), "getAccountMappingOptionList"] as QueryKey,
};
